export default 'filesPage';
